/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, ContractFactory, Signer } from "ethers";
import { Provider } from "ethers/providers";
import { UnsignedTransaction } from "ethers/utils/transaction";

import { TransactionOverrides } from "..";
import { PublicResolver } from "../PublicResolver";

export class PublicResolver__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _ens: string,
    overrides?: TransactionOverrides
  ): Promise<PublicResolver> {
    return super.deploy(_ens, overrides) as Promise<PublicResolver>;
  }
  getDeployTransaction(
    _ens: string,
    overrides?: TransactionOverrides
  ): UnsignedTransaction {
    return super.getDeployTransaction(_ens, overrides);
  }
  attach(address: string): PublicResolver {
    return super.attach(address) as PublicResolver;
  }
  connect(signer: Signer): PublicResolver__factory {
    return super.connect(signer) as PublicResolver__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PublicResolver {
    return new Contract(address, _abi, signerOrProvider) as PublicResolver;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ENS",
        name: "_ens",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
    ],
    name: "ABIChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "AddrChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "newAddress",
        type: "bytes",
      },
    ],
    name: "AddressChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "AuthorisationChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "ContenthashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "record",
        type: "bytes",
      },
    ],
    name: "DNSRecordChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "name",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "DNSRecordDeleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "DNSZoneCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "lastzonehash",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "zonehash",
        type: "bytes",
      },
    ],
    name: "DNSZonehashChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        indexed: false,
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "InterfaceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "NameChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "PubkeyChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "string",
        name: "indexedKey",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "TextChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentTypes",
        type: "uint256",
      },
    ],
    name: "ABI",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
    ],
    name: "addr",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "authorisations",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "clearDNSZone",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "contenthash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint16",
        name: "resource",
        type: "uint16",
      },
    ],
    name: "dnsRecord",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "hasDNSRecords",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "interfaceImplementer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "pubkey",
    outputs: [
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "contentType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setABI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "coinType",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "a",
        type: "bytes",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "a",
        type: "address",
      },
    ],
    name: "setAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bool",
        name: "isAuthorised",
        type: "bool",
      },
    ],
    name: "setAuthorisation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setContenthash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "setDNSRecords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
      {
        internalType: "address",
        name: "implementer",
        type: "address",
      },
    ],
    name: "setInterface",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "setName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "x",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "y",
        type: "bytes32",
      },
    ],
    name: "setPubkey",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
      {
        internalType: "string",
        name: "value",
        type: "string",
      },
    ],
    name: "setText",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "hash",
        type: "bytes",
      },
    ],
    name: "setZonehash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceID",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
      {
        internalType: "string",
        name: "key",
        type: "string",
      },
    ],
    name: "text",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "zonehash",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
